export { ReactComponent as default } from '../assets/svg-icons/telegram.svg';

export { ReactComponent as Telegram } from '../assets/svg-icons/telegram.svg';
